// Plain-English explanations for every product profile option, so the person filling in
// the profile does not have to guess what a term like "field deployed" covers.

export const CATEGORY_HELP = {
  industrial_control: "PLCs, DCS controllers, RTUs, HMIs, drives: equipment that controls an industrial process.",
  machinery_safety_control: "Safety controllers, safety PLCs, safety relays and interlock logic that keep machinery safe.",
  iiot_gateway: "Edge gateways and data concentrators that bridge plant equipment to a network or cloud service.",
  embedded_component: "A board, module, sensor or subassembly that a customer builds into their own product or machine.",
  network_device: "Switches, routers, firewalls, wireless access points and industrial network hardware.",
  software_application: "Software you ship as a product: engineering tools, SCADA or HMI software, mobile or web apps.",
  consumer_device: "Connectable products sold to consumers, such as smart home or wearable devices.",
  other: "Pick this if none of the above fits; scoring falls back to your other answers.",
};

export const CONNECTIVITY_HELP = {
  none: "No network interface at all. Data only moves by hand, for example a USB stick or SD card.",
  local_network: "Talks only on a local or plant network. No route to the public internet.",
  internet: "Reachable from, or able to reach, the public internet directly.",
  cloud_connected: "Maintains an outbound connection to a cloud service, for telemetry, remote control or updates.",
  cellular: "Has its own mobile data connection, for example a SIM or eSIM on 4G, 5G or NB-IoT.",
};

export const DEPLOYMENT_HELP = {
  on_premise_industrial:
    "Installed inside a plant, factory or utility site that you or your customer controls. Physical access is restricted and the network is usually segmented.",
  field_deployed:
    "Installed at remote, unattended or outdoor locations such as substations, pump stations, roadside cabinets, wind turbines or vehicles. Nobody is normally on site, so physical tampering and remote access are the main exposures.",
  customer_network:
    "Shipped to a customer who installs it on a network you do not control and cannot inspect. You have no visibility of their segmentation, firewall rules or who can reach the device.",
  cloud_managed:
    "The product is administered through a cloud service you or a partner operates, so identity, updates and configuration flow through that platform.",
  standalone_offline:
    "Runs isolated with no network connection in normal use. Updates and data transfer happen locally, by hand.",
  not_stated: "Not declared yet. State a deployment model so severity and applicability can be judged properly.",
};

export const CAPABILITY_HELP = {
  remote_access: "Someone can log in or connect from outside the local network, including support VPN and remote desktop.",
  firmware_update: "Firmware or software on the product can be updated after it ships.",
  processes_personal_data: "Handles data about identifiable people: names, credentials, video, location, badge or biometric data.",
  safety_function: "Performs or contributes to a safety function, for example an emergency stop, interlock or protective trip.",
  wireless_interface: "Has any radio: Wi-Fi, Bluetooth, cellular, LoRa, Zigbee or proprietary RF.",
  third_party_components: "Contains open-source or purchased software or hardware components you did not write yourself.",
  debug_interfaces: "Has debug or service access such as UART, JTAG, SWD, a service port or a maintenance shell.",
};

export const INTERFACE_HELP = {
  ethernet: "Wired network port",
  wifi: "Wi-Fi radio",
  cellular: "Mobile data, SIM or eSIM",
  bluetooth: "Bluetooth or BLE",
  usb: "USB host or device port",
  serial_rs485: "RS-232, RS-485 or other serial link",
  can_bus: "CAN or CAN-FD bus",
  debug_uart_jtag: "Debug header: UART, JTAG or SWD",
  web_ui: "Built-in web interface",
  rest_api: "Network API for integration",
  opc_ua: "OPC UA server or client",
  modbus: "Modbus TCP or RTU",
  mqtt: "MQTT publish or subscribe",
  sd_card: "Removable storage slot",
};

export const MARKET_HELP = {
  eu: "Placed on the EU market: EU CRA and, for machinery, the EU Machinery Regulation are considered.",
  uk: "Placed on the GB market: the UKCA route and, for consumer connectable products, UK PSTI are considered.",
  us: "Sold in the United States. No US regime is scored today; recorded for context.",
  apac: "Sold in Asia-Pacific. No regional regime is scored today; recorded for context.",
  other: "Any other territory. Recorded for context only.",
};
